<div class="d-flex align-items-center">
  <input class="form-check-input mt-0 me-3" type="checkbox" attr.aria-label="{{ 'label.terms-of-service' | translate }}" id="termsOfServiceCheckbox" [formControl]="field">
  <label for="termsOfServiceCheckbox">
    <small>
      {{ 'label.confirmedTermsOfService-part-1' | translate }}
      <span (mousedown)="$event.stopPropagation()" (click)="preventClick($event)">
        <a (click)="openDialog('terms-of-service')">
          {{ 'label.confirmedTermsOfService-part-2-link' | translate }}
        </a>
      </span>
      {{ 'label.confirmedTermsOfService-part-3' | translate }}
    </small>
  </label>
</div>

<div *ngIf="hasHint" class="form-text">{{ hint | translate }}</div>
<div *ngIf="showError" class="form-text text-danger">{{ error | translate }}</div>
